import React from "react";
import { Typography } from "@kelp-dao/kernel-design-system";
import VaultCard from "./VaultCard";
import { VaultItem } from "./types";

interface VaultGridProps {
  title: string;
  vaults: VaultItem[];
  onVaultClick?: (vault: VaultItem) => void;
}

const VaultGrid: React.FC<VaultGridProps> = ({
  title,
  vaults,
  onVaultClick,
}) => {
  if (vaults.length === 0) {
    return null;
  }

  return (
    <div className="w-full">
      <div className="flex gap-2 items-center mb-4">
        <Typography
          type="heading"
          variant="xxsmall"
          className="text-text-primary font-medium"
        >
          {title}
        </Typography>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {vaults.map((vault) => (
          <VaultCard key={vault.key} vault={vault} onClick={onVaultClick} />
        ))}
      </div>
    </div>
  );
};

export default VaultGrid;
